import { createIconDefinition } from '../../../../cross-team-shared/icons/create-icon-definition';

export const rectangleIcon = createIconDefinition(
  'rectangle',
  `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.8333 3.33301H4.16667C3.25 3.33301 2.5 4.08301 2.5 4.99967V14.9997C2.5 15.9163 3.25 16.6663 4.16667 16.6663H15.8333C16.75 16.6663 17.5 15.9163 17.5 14.9997V4.99967C17.5 4.08301 16.75 3.33301 15.8333 3.33301ZM15.8333 14.9997H4.16667V4.99967H15.8333V14.9997Z" fill="#232426" fill-opacity="0.6"/>
</svg>`,
);
